import { render, staticRenderFns } from "./AgVtDatePicker.vue?vue&type=template&id=5d8786a9&scoped=true&"
import script from "./AgVtDatePicker.vue?vue&type=script&lang=js&"
export * from "./AgVtDatePicker.vue?vue&type=script&lang=js&"
import style0 from "./AgVtDatePicker.vue?vue&type=style&index=0&id=5d8786a9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8786a9",
  null
  
)

export default component.exports